import type { RouteRecordRaw, Router } from 'vue-router'

const EstateDonationContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/donation',
  name: 'EstateDonationModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EstateDonationMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'donationEstate.donationContract',
      },
    },
    {
      path: 'create',
      name: 'EstateDonationCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'donationEstate.createDonationContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'EstateDonationEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'donationEstate.editDonationContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewEstateDonationRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'donationEstate.ViewDonation',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(EstateDonationContractRoutes)
}
